module.exports = __webpack_public_path__ + "img/avatar-s-22.da5e73c7.jpg";